// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".file{margin:20px 15px 20px 0;cursor:pointer;position:relative}.file:hover{-webkit-transform:translateY(-2px);transform:translateY(-2px);-webkit-box-shadow:0 5px 20px rgba(0,0,0,.3);box-shadow:0 5px 20px rgba(0,0,0,.3)}.file-body{z-index:0}.file-body.nav{height:90px;width:180px}.file-footer{position:absolute;bottom:0;left:0;height:40%;width:100%;z-index:10;background-color:rgba(0,0,0,.4);border-bottom-left-radius:10px;border-bottom-right-radius:10px}", ""]);
// Exports
module.exports = exports;
